export const mutationKeys = {
  startApplication: (applicationId: string) => ['startApplication', applicationId],
  withdraw: ['withdraw']
};
